(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Slide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.teardown();
      }

      init() {
        if (this.ready || !this.isConnected) return;

        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2) return;

        this.ready = true;
        this.ac = new AbortController();
        const signal = this.ac.signal;

        this.index = 0;
        this.locked = false;
        this.holds = new Set();
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.effect = this.dataset.effect === 'fade' ? 'fade' : 'slide';
        this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.duration = parseInt(this.dataset.duration, 10) || 600;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduced;

        const viewport = this.querySelector('[data-viewport]') || this;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.step(-1), { signal });
        if (next) next.addEventListener('click', () => this.step(1), { signal });

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.go(i, i > this.index ? 1 : -1), { signal });
        });

        this.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'ArrowLeft') this.step(-1);
            if (e.key === 'ArrowRight') this.step(1);
          },
          { signal }
        );

        /* Swipe */
        viewport.addEventListener(
          'touchstart',
          (e) => {
            const t = e.changedTouches[0];
            this.tx = t.clientX;
            this.ty = t.clientY;
            this.hold('touch');
          },
          { signal, passive: true }
        );
        viewport.addEventListener(
          'touchend',
          (e) => {
            const t = e.changedTouches[0];
            const dx = t.clientX - this.tx;
            const dy = t.clientY - this.ty;
            this.release('touch');
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.step(dx < 0 ? 1 : -1);
          },
          { signal, passive: true }
        );
        viewport.addEventListener('touchcancel', () => this.release('touch'), { signal, passive: true });

        /* Pause rules for autoplay */
        this.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && this.hold('hover'), { signal });
        this.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && this.release('hover'), { signal });
        this.addEventListener('focusin', (e) => e.target.matches(':focus-visible') && this.hold('focus'), { signal });
        this.addEventListener('focusout', () => this.release('focus'), { signal });
        document.addEventListener(
          'visibilitychange',
          () => (document.hidden ? this.hold('hidden') : this.release('hidden')),
          { signal }
        );

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([entry]) => (entry.isIntersecting ? this.release('offscreen') : this.hold('offscreen')),
            { threshold: 0.2 }
          );
          this.io.observe(this);
        }

        /* Theme editor support */
        this.addEventListener(
          'shopify:block:select',
          (e) => {
            const i = this.slides.indexOf(e.target.closest('[data-slide]'));
            this.hold('editor');
            if (i > -1) this.go(i, i > this.index ? 1 : -1, true);
          },
          { signal }
        );
        this.addEventListener('shopify:block:deselect', () => this.release('editor'), { signal });

        this.start();
      }

      applyRatio(slide) {
        const d = parseFloat(slide.dataset.ratioD);
        const t = parseFloat(slide.dataset.ratioT);
        const m = parseFloat(slide.dataset.ratioM);
        if (d > 0) this.style.setProperty('--hs-ratio-d', d);
        if (t > 0) this.style.setProperty('--hs-ratio-t', t);
        if (m > 0) this.style.setProperty('--hs-ratio-m', m);
      }

      teardown() {
        this.stop();
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        this.ready = false;
      }

      hold(key) {
        this.holds.add(key);
        this.stop();
      }

      release(key) {
        if (!this.holds.delete(key)) return;
        if (!this.holds.size) this.start();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.holds.size) return;
        this.timer = setTimeout(() => this.step(1), this.delay);
      }

      stop() {
        clearTimeout(this.timer);
      }

      step(dir) {
        const n = this.slides.length;
        this.go((this.index + dir + n) % n, dir);
      }

      go(next, dir, force) {
        if (next === this.index) return;
        if (this.locked && !force) return;

        this.locked = true;
        setTimeout(() => (this.locked = false), this.duration);

        const prev = this.slides[this.index];
        const incoming = this.slides[next];

        clearTimeout(incoming._t);
        incoming.classList.remove('is-leaving');

        if (this.effect === 'slide') {
          incoming.style.transition = 'none';
          incoming.style.setProperty('--o', dir);
          incoming.classList.add('is-active');
          void incoming.offsetWidth;
          incoming.style.transition = '';
          incoming.style.setProperty('--o', 0);
          prev.style.setProperty('--o', -dir);
        } else {
          incoming.classList.add('is-active');
        }

        incoming.inert = false;
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        prev.inert = true;
        clearTimeout(prev._t);
        prev._t = setTimeout(() => prev.classList.remove('is-leaving'), this.duration + 50);

        this.dots.forEach((dot, i) => {
          if (i === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.index = next;
        this.applyRatio(incoming);
        this.start();
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
